//Name,Symbol,Weight,Price,Change,Change %
export default [
  ["Apple Inc", "AAPL", 6.992488, 171.9, 1.47, "(0.86%)"],
  ["Microsoft Corp", "MSFT", 6.487978, 314.55, 1.76, "(0.56%)"],
  ["Amazon.com Inc", "AMZN", 3.193379, 126.25, 0.27, "(0.22%)"],
  ["Nvidia Corp", "NVDA", 2.928461, 433.11, 8.43, "(1.99%)"],
  ["Alphabet Inc Cl A", "GOOGL", 2.162218, 132.93, 2.39, "(1.83%)"],
  ["Tesla Inc", "TSLA", 1.854311, 246.56, 6.06, "(2.52%)"],
  ["Alphabet Inc Cl C", "GOOG", 1.85251, 133.81, 2.35, "(1.78%)"],
  ["Meta Platforms Inc Class A", "META", 1.847731, 305.93, 8.19, "(2.75%)"],
  ["Berkshire Hathaway Inc Cl B", "BRK.B", 1.82184, 358.67, 0.89, "(0.25%)"],
  ["Exxon Mobil Corp", "XOM", 1.343563, 118.97, -1.23, "(-1.03%)"],
  ["Unitedhealth Group Inc", "UNH", 1.302884, 510.04, 6.31, "(1.25%)"],
  ["Eli Lilly & Co", "LLY", 1.224046, 546.65, -3.11, "(-0.57%)"],
  ["Jpmorgan Chase & Co", "JPM", 1.182918, 148.23, 2.45, "(1.68%)"],
  ["Johnson & Johnson W/d", "JNJ", 1.056344, 156.83, -0.28, "(-0.18%)"],
  ["Visa Inc Class a Shares", "V", 1.029636, 231.97, 2.47, "(1.08%)"],
  ["Procter & Gamble Co", "PG", 0.969793, 145.75, -1.59, "(-1.08%)"],
  ["Broadcom Inc", "AVGO", 0.941177, 835.33, 18.52, "(2.27%)"],
  ["Mastercard Inc A", "MA", 0.918779, 400.65, 5.17, "(1.31%)"],
  ["Chevron Corp", "CVX", 0.847353, 170.55, -0.49, "(-0.28%)"],
  ["Home Depot Inc", "HD", 0.847289, 304.35, 2.53, "(0.84%)"],
  ["Abbvie Inc", "BBV", 0.754672, 152.14, -0.99, "(-0.65%)"],
  ["Merck & Co. Inc.", "MRK", 0.736434, 104.2, 0.26, "(0.25%)"],
  ["Costco Wholesale Corp", "COST", 0.697258, 569.05, 5.52, "(0.98%)"],
  ["Pepsico Inc", "PEP", 0.651768, 168.92, -0.65, "(-0.38%)"],
  ["Walmart Inc", "WMT", 0.644449, 161.87, 0.15, "(0.09%)"],
  ["Adobe Inc", "ADBE", 0.639652, 507.17, 4.57, "(0.91%)"],
  ["Coca Cola Co", "KO", 0.60801, 55.82, -0.13, "(-0.23%)"],
  ["Cisco Systems Inc", "CSCO", 0.605326, 53.97, 0.77, "(1.44%)"],
  ["Accenture Plc Cl A", "ACN", 0.55372, 298.5, -15.9, "(-5.05%)"],
  ["Salesforce Inc", "CRM", 0.551342, 204.46, 1.73, "(0.85%)"],
  ["Thermo Fisher Scientific Inc", "TMO", 0.536951, 503.47, 5.18, "(1.04%)"],
  ["Mcdonald S Corp", "MCD", 0.536457, 265.83, 2.19, "(0.83%)"],
  ["Bank of America Corp", "BAC", 0.526405, 27.51, 0.24, "(0.86%)"],
  ["Comcast Corp Class A", "CMCSA", 0.512537, 45.17, 0.57, "(1.27%)"],
  ["Linde Plc", "LIN", 0.506835, 375.48, 3.47, "(0.93%)"],
  ["Pfizer Inc", "PFE", 0.506043, 32.09, -0.02, "(-0.05%)"],
  ["Netflix Inc", "NFLX", 0.467192, 377.77, 0.18, "(0.05%)"],
  ["Abbott Laboratories", "ABT", 0.462893, 97.52, 1.99, "(2.08%)"],
  ["Oracle Corp", "ORCL", 0.459877, 106.29, 1.67, "(1.60%)"],
];

/*
41,Danaher Corp,DHR,0.454026,248.24,0.80,(0.32%)
42,Advanced Micro Devices,AMD,0.442473,103.74,5.67,(5.78%)
43,Wells Fargo & Co,WFC,0.417428,41.04,0.18,(0.43%)
44,Conocophillips,COP,0.411569,123.32,0.23,(0.18%)
45,Walt Disney Co,DIS,0.408438,80.35,0.45,(0.56%)
46,Intel Corp,INTC,0.404462,35.50,0.89,(2.56%)
47,Amgen Inc,AMGN,0.401904,270.91,1.93,(0.72%)
48,Texas Instruments Inc,TXN,0.400931,160.98,2.84,(1.80%)
49,Intuit Inc,INTU,0.397406,515.11,6.87,(1.35%)
50,Philip Morris International,PM,0.39143,92.66,2.34,(2.59%)
51,Caterpillar Inc,CAT,0.388444,276.34,3.63,(1.33%)
52,Verizon Communications Inc,VZ,0.380327,32.56,0.16,(0.48%)
53,Intl Business Machines Corp,IBM,0.364246,140.89,-2.28,(-1.59%)
54,Honeywell International Inc,HON,0.348317,188.68,0.80,(0.43%)
55,Union Pacific Corp,UNP,0.344419,203.88,1.48,(0.73%)
56,Qualcomm Inc,QCOM,0.340195,111.55,2.36,(2.16%)
57,Nextera Energy Inc,NEE,0.338809,57.64,-2.32,(-3.88%)
58,Lowe S Cos Inc,LOW,0.338613,209.52,2.56,(1.24%)
59,Bristol Myers Squibb Co,BMY,0.337683,58.30,0.41,(0.70%)
60,General Electric Co,GE,0.336989,112.43,1.54,(1.39%)
61,S&p Global Inc,SPGI,0.32985,369.21,6.15,(1.69%)
62,Applied Materials Inc,AMAT,0.316678,139.15,4.09,(3.03%)
63,Servicenow Inc,NOW,0.3112,552.84,6.46,(1.18%)
64,Boeing Co,BA,0.309673,193.12,-2.34,(-1.20%)
65,United Parcel Service Cl B,UPS,0.307795,154.29,1.88,(1.23%)
66,Booking Holdings Inc,BKNG,0.307126,3,086.26,3.60,(0.12%)
67,Nike Inc Cl B,NKE,0.305871,89.63,0.21,(0.24%)
68,At&t Inc,T,0.296603,14.94,0.07,(0.44%)
69,Goldman Sachs Group Inc,GS,0.296356,325.72,3.77,(1.17%)
70,Rtx Corp,RTX,0.296189,72.54,-0.34,(-0.46%)
71,Elevance Health Inc,ELV,0.292632,448.99,4.23,(0.95%)
72,Deere & Co,DE,0.291602,388.36,4.00,(1.04%)
73,Starbucks Corp,SBUX,0.291579,91.21,0.04,(0.04%)
74,Morgan Stanley,MS,0.29087,82.34,0.69,(0.84%)
75,Medtronic Plc,MDT,0.290688,78.77,0.55,(0.71%)
76,Prologis Inc,PLD,0.286912,112.30,1.05,(0.94%)
77,Intuitive Surgical Inc,ISRG,0.285764,296.31,4.88,(1.67%)
78,Tjx Companies Inc,TJX,0.282733,89.27,1.16,(1.32%)
79,Automatic Data Processing,ADP,0.279113,243.79,1.16,(0.48%)
80,Marsh & Mclennan Cos,MMC,0.266169,193.53,0.55,(0.29%)
81,Mondelez International Inc A,MDLZ,0.26425,69.44,-0.56,(-0.79%)
82,Gilead Sciences Inc,GILD,0.26285,75.96,0.41,(0.54%)
83,Lockheed Martin Corp,LMT,0.255775,410.40,1.68,(0.41%)
84,Blackrock Inc,BLK,0.252096,645.37,1.98,(0.31%)
85,Vertex Pharmaceuticals Inc,VRTX,0.251521,353.91,4.26,(1.22%)
86,Stryker Corp,SYK,0.250789,273.07,6.53,(2.45%)
87,Cvs Health Corp,CVS,0.250255,70.11,0.33,(0.47%)
88,Regeneron Pharmaceuticals,REGN,0.2481,835.67,3.11,(0.37%)
89,American Express Co,AXP,0.243515,150.42,0.52,(0.34%)
90,Chubb Ltd,CB,0.242706,212.92,1.29,(0.61%)
91,Analog Devices Inc,ADI,0.241943,177.01,4.20,(2.43%)
92,Schlumberger Ltd,SLB,0.241232,61.02,0.22,(0.36%)
93,Eaton Corp Plc,ETN,0.238556,216.42,2.06,(0.96%)
94,The Cigna Group,CI,0.238517,291.43,2.82,(0.98%)
95,Progressive Corp,PGR,0.229854,140.76,0.14,(0.10%)
96,Lam Research Corp,LRCX,0.228483,627.46,13.54,(2.20%)
97,Schwab (Charles) Corp,SCHW,0.225784,54.57,0.19,(0.35%)
98,Zoetis Inc,ZTS,0.224522,174.68,-0.00,(-0.00%)
99,Citigroup Inc,C,0.217552,41.24,0.78,(1.92%)
100,Boston Scientific Corp,BSX,0.213003,53.30,1.20,(2.31%)
101,Blackstone Inc,BX,0.211158,108.88,2.33,(2.19%)
102,Eog Resources Inc,EOG,0.21104,130.56,0.75,(0.57%)
103,Becton Dickinson and Co,BDX,0.209627,262.60,3.80,(1.47%)
104,Micron Technology Inc,MU,0.208276,66.25,-1.96,(-2.87%)
105,American Tower Corp,AMT,0.207727,160.73,1.04,(0.65%)
106,Altria Group Inc,MO,0.207666,42.11,0.20,(0.47%)
107,T Mobile Us Inc,TMUS,0.20192,140.30,0.60,(0.43%)
108,Cme Group Inc,CME,0.201368,200.22,-0.14,(-0.07%)
109,Southern Co,SO,0.20116,65.04,-1.10,(-1.67%)
110,Palo Alto Networks Inc,PANW,0.198047,236.42,4.52,(1.95%)
111,Duke Energy Corp,DUK,0.193827,88.87,-1.23,(-1.36%)
112,Fiserv Inc,FI,0.192662,113.67,0.48,(0.42%)
113,Synopsys Inc,SNPS,0.189768,458.88,12.17,(2.72%)
114,Activision Blizzard Inc,ATVI,0.18717,93.71,-0.22,(-0.23%)
115,Aon Plc Class A,AON,0.186896,330.04,0.12,(0.04%)
116,Equinix Inc,EQIX,0.184757,715.84,8.74,(1.24%)
117,Illinois Tool Works,ITW,0.177501,233.17,0.77,(0.33%)
118,Air Products & Chemicals Inc,APD,0.17678,289.15,3.89,(1.36%)
119,Paypal Holdings Inc,PYPL,0.175802,58.30,0.96,(1.67%)
120,Cadence Design Sys Inc,CDNS,0.175052,235.09,4.44,(1.93%)
121,Northrop Grumman Corp,NOC,0.173654,441.30,4.06,(0.93%)
122,Intercontinental Exchange In,ICE,0.172998,109.93,1.66,(1.53%)
123,Humana Inc,HUM,0.170476,495.73,2.16,(0.44%)
124,Marathon Petroleum Corp,MPC,0.170186,155.28,2.85,(1.87%)
125,Kla Corp,KLAC,0.170079,459.61,14.05,(3.15%)
126,Fedex Corp,FDX,0.169747,266.99,4.28,(1.63%)
127,Csx Corp,CSX,0.169632,30.62,0.34,(1.14%)
128,Mckesson Corp,MCK,0.167376,445.58,1.20,(0.27%)
129,Sherwin Williams Co,SHW,0.165389,254.95,4.33,(1.73%)
130,Colgate Palmolive Co,CL,0.164,71.11,0.06,(0.08%)
131,Airbnb Inc Class A,ABNB,0.159553,137.66,3.63,(2.70%)
132,Waste Management Inc,WM,0.15893,154.17,-0.25,(-0.16%)
133,Emerson Electric Co,EMR,0.154857,97.31,0.45,(0.47%)
134,O Reilly Automotive Inc,ORLY,0.154194,918.15,3.98,(0.44%)
135,Pioneer Natural Resources Co,PXD,0.1524,234.43,0.34,(0.14%)
136,Phillips 66,PSX,0.150197,122.81,2.01,(1.66%)
137,Freeport Mcmoran Inc,FCX,0.146185,37.34,0.79,(2.17%)
138,3m Co W/d,MMM,0.144312,93.48,0.02,(0.02%)
139,Roper Technologies Inc,ROP,0.144165,486.61,-0.02,(-0.00%)
140,Valero Energy Corp,VLO,0.141937,147.59,3.64,(2.53%)
141,Nxp Semiconductors Nv,NXPI,0.141583,202.19,5.49,(2.79%)
142,Target Corp,TGT,0.141106,109.31,-0.44,(-0.40%)
143,Parker Hannifin Corp,PH,0.140358,396.29,5.18,(1.32%)
144,Us Bancorp,USB,0.139291,32.59,0.07,(0.20%)
145,General Dynamics Corp,GD,0.139193,223.44,2.44,(1.10%)
146,Chipotle Mexican Grill Inc,CMG,0.139055,1,828.59,22.51,(1.25%)
147,Hca Healthcare Inc,HCA,0.138966,251.59,4.33,(1.75%)
148,Arthur J Gallagher & Co,AJG,0.138231,231.77,1.44,(0.62%)
149,Moody S Corp,MCO,0.138162,319.07,4.56,(1.45%)
150,Amphenol Corp Cl A,APH,0.136941,84.40,2.04,(2.47%)
151,Ford Motor Co,F,0.1362,12.58,0.19,(1.49%)
152,Marriott International Cl A,MAR,0.135619,199.53,5.65,(2.92%)
153,Pnc Financial Services Group,PNC,0.135457,123.09,1.28,(1.05%)
154,Transdigm Group Inc,TDG,0.131273,860.46,8.64,(1.01%)
155,Carrier Global Corp,CARR,0.129065,56.83,1.75,(3.17%)
156,Autozone Inc,AZO,0.128857,2,556.17,15.27,(0.60%)
157,Trane Technologies Plc,TT,0.12759,207.07,7.01,(3.50%)
158,Motorola Solutions Inc,MSI,0.127284,275.18,2.20,(0.81%)
159,Arista Networks Inc,ANET,0.12715,184.23,2.63,(1.45%)
160,Norfolk Southern Corp,NSC,0.124378,197.30,1.08,(0.55%)
161,General Motors Co,GM,0.124282,33.25,0.90,(2.77%)
162,Paccar Inc,PCAR,0.123613,86.12,1.31,(1.54%)
163,Charter Communications Inc A,CHTR,0.123199,442.28,8.86,(2.04%)
164,Hess Corp,HES,0.121942,157.30,-0.74,(-0.47%)
165,Sempra,SRE,0.121909,68.15,-1.26,(-1.81%)
166,Occidental Petroleum Corp,OXY,0.121531,66.03,0.43,(0.66%)
167,American International Group,AIG,0.121272,61.73,0.72,(1.18%)
168,Autodesk Inc,ADSK,0.120711,208.03,5.75,(2.84%)
169,Edwards Lifesciences Corp,EW,0.119074,69.68,-0.43,(-0.62%)
170,Ecolab Inc,ECL,0.118911,169.50,1.63,(0.97%)
171,Public Storage,PSA,0.117206,266.58,1.60,(0.60%)
172,Microchip Technology Inc,MCHP,0.116275,78.91,2.41,(3.15%)
173,Aflac Inc,AFL,0.11627,77.65,0.62,(0.81%)
174,Cintas Corp,CTAS,0.116227,486.83,5.75,(1.19%)
175,Welltower Inc,WELL,0.116157,81.07,0.87,(1.08%)
176,Williams Cos Inc,WMB,0.115685,34.65,0.55,(1.61%)
177,Kimberly Clark Corp,KMB,0.114902,121.11,-0.55,(-0.45%)
178,Archer Daniels Midland Co,ADM,0.114307,76.74,0.38,(0.50%)
179,Msci Inc,MSCI,0.113047,518.97,7.03,(1.37%)
180,Constellation Brands Inc A,STZ,0.112869,251.62,1.03,(0.41%)
181,On Semiconductor,ON,0.111009,95.12,3.07,(3.33%)
182,Metlife Inc,MET,0.110772,63.06,0.26,(0.41%)
183,Monster Beverage Corp,MNST,0.110311,53.31,0.19,(0.35%)
184,Hilton Worldwide Holdings In,HLT,0.109054,153.24,3.88,(2.60%)
185,American Electric Power,AEP,0.108899,74.71,-1.15,(-1.51%)
186,Crown Castle Inc,CCI,0.108512,91.35,1.65,(1.83%)
187,Exelon Corp,EXC,0.107894,38.11,-0.69,(-1.78%)
188,Nucor Corp,NUE,0.107787,158.31,2.60,(1.67%)
189,Travelers Cos Inc,TRV,0.107342,167.42,-0.51,(-0.30%)
190,Dominion Energy Inc,D,0.106001,44.61,-0.86,(-1.88%)
191,Te Connectivity Ltd,TEL,0.105581,123.84,3.40,(2.82%)
192,Halliburton Co,HAL,0.105449,42.18,0.15,(0.37%)
193,Centene Corp,CNC,0.105443,69.87,0.13,(0.18%)
194,Fortinet Inc,FTNT,0.105315,59.07,0.93,(1.59%)
195,Oneok Inc,OKE,0.104854,64.86,0.35,(0.53%)
196,General Mills Inc,GIS,0.104655,63.79,-0.26,(-0.40%)
197,Copart Inc,CPRT,0.104453,43.66,0.61,(1.41%)
198,Paychex Inc,PAYX,0.104412,117.40,0.89,(0.76%)
199,Biogen Inc,BIIB,0.103916,258.95,1.43,(0.55%)
200,Truist Financial Corp,TFC,0.103679,28.15,0.18,(0.63%)
201,Ross Stores Inc,ROST,0.10361,111.18,2.26,(2.07%)
202,Johnson Controls Internation,JCI,0.103601,53.69,-0.85,(-1.55%)
203,Iqvia Holdings Inc,IQV,0.103397,200.11,-2.10,(-1.04%)
204,Capital One Financial Corp,COF,0.101688,96.63,1.14,(1.20%)
205,Baker Hughes Co,BKR,0.101425,36.62,0.37,(1.02%)
206,Idexx Laboratories Inc,IDXX,0.101263,439.37,2.51,(0.57%)
207,Corteva Inc,CTVA,0.100577,50.77,0.02,(0.05%)
208,Dow Inc,DOW,0.100258,50.87,-0.13,(-0.26%)
209,Old Dominion Freight Line,ODFL,0.100037,406.82,6.93,(1.73%)
210,Constellation Energy,CEG,0.099445,109.94,-0.81,(-0.73%)
211,Dexcom Inc,DXCM,0.099384,95.68,3.59,(3.90%)
212,Simon Property Group Inc,SPG,0.098977,108.45,0.26,(0.24%)
213,Digital Realty Trust Inc,DLR,0.098757,117.60,0.76,(0.65%)
214,Realty Income Corp,O,0.098278,49.83,0.17,(0.33%)
215,Kenvue Inc W/i,KVUE,0.097359,20.20,-0.02,(-0.12%)
216,Verisk Analytics Inc,VRSK,0.097203,241.97,2.34,(0.98%)
217,Cognizant Tech Solutions A,CTSH,0.096172,68.15,-0.05,(-0.07%)
218,P G & E Corp,PCG,0.095995,16.36,-0.09,(-0.52%)
219,Prudential Financial Inc,PRU,0.095804,94.93,0.41,(0.43%)
220,Ametek Inc,AME,0.09567,150.03,1.17,(0.79%)
221,Yum Brands Inc,YUM,0.095443,123.55,1.57,(1.29%)
222,Dupont De Nemours Inc,DD,0.094185,74.58,1.11,(1.51%)
223,Ameriprise Financial Inc,AMP,0.093691,332.11,5.16,(1.58%)
224,L3harris Technologies Inc,LHX,0.092512,173.16,-2.04,(-1.16%)
225,Fidelity National Info Serv,FIS,0.09207,56.06,0.52,(0.94%)
226,Sysco Corp,SYY,0.091968,65.99,0.78,(1.20%)
227,Moderna Inc,MRNA,0.091789,100.61,1.17,(1.18%)
228,Bank of New York Mellon Corp,BK,0.091699,42.76,0.59,(1.39%)
229,Agilent Technologies Inc,A,0.091382,111.91,1.41,(1.28%)
230,Otis Worldwide Corp,OTIS,0.091228,80.55,1.20,(1.51%)
231,Rockwell Automation Inc,ROK,0.091103,288.26,3.46,(1.21%)
232,Dr Horton Inc,DHI,0.090974,108.96,1.95,(1.82%)
233,Cummins Inc,CMI,0.090916,232.98,3.03,(1.32%)
234,Estee Lauder Companies Cl A,EL,0.090788,139.94,-0.10,(-0.07%)
235,Kinder Morgan Inc,KMI,0.090175,16.71,0.05,(0.27%)
236,Keurig Dr Pepper Inc,KDP,0.088358,31.51,-0.16,(-0.51%)
237,Fastenal Co,FAST,0.087952,55.72,0.66,(1.21%)
238,Xcel Energy Inc,XEL,0.087474,56.50,-0.71,(-1.25%)
239,Devon Energy Corp,DVN,0.087359,48.84,0.00,(0.01%)
240,Ww Grainger Inc,GWW,0.086956,704.07,3.96,(0.57%)
241,Costar Group Inc,CSGP,0.086756,77.10,0.75,(0.99%)
242,Cencora Inc,COR,0.086188,183.99,-1.17,(-0.63%)
243,United Rentals Inc,URI,0.085093,454.44,8.22,(1.84%)
244,Hershey Co,HSY,0.084755,201.01,-1.55,(-0.76%)
245,Arch Capital Group Ltd,ACGL,0.083799,81.62,0.54,(0.67%)
246,Ppg Industries Inc,PPG,0.083787,130.49,2.46,(1.92%)
247,Global Payments Inc,GPN,0.083671,116.72,1.47,(1.28%)
248,Consolidated Edison Inc,ED,0.083432,85.06,-1.57,(-1.81%)
249,Newmont Corp,NEM,0.082799,36.78,-0.50,(-1.34%)
250,Republic Services Inc,RSG,0.082765,145.01,0.28,(0.19%)
251,Allstate Corp,ALL,0.08254,112.77,-0.25,(-0.22%)
252,Electronic Arts Inc,EA,0.081213,119.76,1.79,(1.51%)
253,Vici Properties Inc,VICI,0.081127,29.28,0.40,(1.37%)
254,Kroger Co,KR,0.080998,44.96,0.48,(1.07%)
255,Public Service Enterprise Gp,PEG,0.080723,56.88,-1.02,(-1.75%)
256,Lennar Corp A,LEN,0.078759,113.41,1.71,(1.53%)
257,Diamondback Energy Inc,FANG,0.078498,158.01,0.78,(0.50%)
258,West Pharmaceutical Services,WST,0.077362,377.15,1.97,(0.52%)
259,Quanta Services Inc,PWR,0.077074,190.82,0.70,(0.37%)
260,Gartner Inc,IT,0.076911,347.78,-1.41,(-0.40%)
261,Aptiv Plc,APTV,0.0757,99.21,3.35,(3.50%)
262,Vulcan Materials Co,VMC,0.075604,207.60,4.00,(1.97%)
263,Kraft Heinz Co,KHC,0.075468,33.72,-0.31,(-0.90%)
264,Ge Healthcare Technology,GEHC,0.074734,69.81,1.53,(2.24%)
265,Cdw Corp/de,CDW,0.074375,202.53,3.84,(1.93%)
266,Fortive Corp,FTV,0.072323,74.75,1.16,(1.58%)
267,Ingersoll Rand Inc,IR,0.071683,64.52,1.25,(1.97%)
268,Ansys Inc,ANSS,0.071343,299.19,4.85,(1.65%)
269,Extra Space Storage Inc,EXR,0.071269,120.75,0.24,(0.20%)
270,Wec Energy Group Inc,WEC,0.071007,79.67,-0.91,(-1.12%)
271,Martin Marietta Materials,MLM,0.070759,418.00,8.05,(1.96%)
272,Edison International,EIX,0.068887,63.92,-1.38,(-2.11%)
273,American Water Works Co Inc,AWK,0.068233,123.27,-3.07,(-2.43%)
274,Warner Bros Discovery Inc,WBD,0.068207,10.89,-0.15,(-1.31%)
275,Lyondellbasell Indu Cl A,LYB,0.067294,94.86,-0.11,(-0.11%)
276,Mettler Toledo International,MTD,0.067028,1,112.26,14.48,(1.32%)
277,Avalonbay Communities Inc,AVB,0.066762,171.85,-0.60,(-0.35%)
278,Delta Air Lines Inc,DAL,0.065781,37.32,0.66,(1.79%)
279,T Rowe Price Group Inc,TROW,0.064996,104.73,1.19,(1.15%)
280,Keysight Technologies In,KEYS,0.064934,133.51,3.11,(2.38%)
281,Zimmer Biomet Holdings Inc,ZBH,0.064476,112.14,1.38,(1.24%)
282,Dollar General Corp,DG,0.064042,105.04,0.70,(0.67%)
283,Corning Inc,GLW,0.064037,30.35,0.29,(0.98%)
284,Ebay Inc,EBAY,0.063728,43.45,0.56,(1.31%)
285,Cbre Group Inc A,CBRE,0.063578,73.84,0.35,(0.48%)
286,Weyerhaeuser Co,WY,0.063312,30.40,-0.64,(-2.05%)
287,Church & Dwight Co Inc,CHD,0.062765,91.68,-0.29,(-0.31%)
288,Cardinal Health Inc,CAH,0.062583,88.18,0.14,(0.16%)
289,Hp Inc,HPQ,0.062013,25.73,0.09,(0.36%)
290,Equifax Inc,EFX,0.061821,185.40,4.68,(2.59%)
291,Tractor Supply Company,TSCO,0.061683,205.07,2.06,(1.02%)
292,Willis Towers Watson Plc,WTW,0.06168,211.96,0.35,(0.17%)
293,Hewlett Packard Enterprise,HPE,0.061499,17.70,0.63,(3.66%)
294,Fair Isaac Corp,FICO,0.061481,890.19,4.58,(0.52%)
295,Dollar Tree Inc,DLTR,0.061287,106.46,1.11,(1.05%)
296,Hartford Financial Svcs Grp,HIG,0.061236,72.24,0.53,(0.73%)
297,Resmed Inc,RMD,0.060853,149.81,1.16,(0.78%)
298,Take Two Interactive Softwre,TTWO,0.060753,139.63,1.85,(1.34%)
299,Royal Caribbean Cruises Ltd,RCL,0.060515,94.38,2.42,(2.64%)
300,Xylem Inc,XYL,0.060192,91.40,1.09,(1.20%)
301,Align Technology Inc,ALGN,0.060095,309.06,7.38,(2.45%)
302,Steris Plc,STE,0.060013,221.57,3.67,(1.69%)
303,Broadridge Financial Solutio,BR,0.059572,181.18,-0.04,(-0.02%)
304,Discover Financial Services,DFS,0.059507,86.35,1.09,(1.28%)
305,State Street Corp,STT,0.059411,67.81,1.03,(1.54%)
306,Sba Communications Corp,SBAC,0.059216,198.11,2.05,(1.05%)
307,Monolithic Power Systems Inc,MPWR,0.058699,457.69,16.51,(3.74%)
308,Illumina Inc,ILMN,0.058584,133.02,-0.28,(-0.21%)
309,Dte Energy Company,DTE,0.058057,98.82,-1.72,(-1.71%)
310,M & T Bank Corp,MTB,0.057846,126.63,2.09,(1.68%)
311,Coterra Energy Inc,CTRA,0.057589,27.48,0.34,(1.23%)
312,Eversource Energy,ES,0.057281,57.54,-1.23,(-2.09%)
313,Genuine Parts Co,GPC,0.055796,142.94,0.63,(0.45%)
314,Equity Residential,EQR,0.055712,58.67,0.23,(0.40%)
315,Entergy Corp,ETR,0.055241,92.23,-1.02,(-1.10%)
316,Dover Corp,DOV,0.055103,141.68,1.09,(0.77%)
317,Ameren Corporation,AEE,0.054981,74.60,-1.51,(-1.98%)
318,Ulta Beauty Inc,ULTA,0.054585,398.17,5.73,(1.46%)
319,Teledyne Technologies Inc,TDY,0.054228,414.36,0.92,(0.22%)
320,Nvr Inc,NVR,0.054188,6,027.42,86.42,(1.45%)
321,Targa Resources Corp,TRGP,0.05408,87.52,0.93,(1.08%)
322,Molina Healthcare Inc,MOH,0.053618,333.09,2.03,(0.61%)
323,Wabtec Corp,WAB,0.053425,108.18,1.35,(1.26%)
324,Fleetcor Technologies Inc,FLT,0.053345,260.14,1.28,(0.49%)
325,Albemarle Corp,ALB,0.053229,172.99,10.36,(6.37%)
326,Baxter International Inc,BAX,0.05272,37.54,0.21,(0.57%)
327,Raymond James Financial Inc,RJF,0.052247,101.39,1.84,(1.85%)
328,Mccormick & Co Non Vtg Shrs,MKC,0.051871,74.55,0.46,(0.63%)
329,Invitation Homes Inc,INVH,0.051153,31.73,0.03,(0.11%)
330,Firstenergy Corp,FE,0.050777,34.56,-0.69,(-1.94%)
331,Laboratory Crp of Amer Hldgs,LH,0.05072,204.23,-0.62,(-0.30%)
332,Howmet Aerospace Inc,HWM,0.050386,46.99,0.91,(1.97%)
333,Verisign Inc,VRSN,0.050215,202.93,2.46,(1.23%)
334,Ppl Corp,PPL,0.04902,23.56,-0.39,(-1.61%)
335,Iron Mountain Inc,IRM,0.047985,59.55,0.56,(0.94%)
336,Jacobs Solutions Inc,J,0.047882,136.45,0.27,(0.20%)
337,Intl Flavors & Fragrances,IFF,0.047868,67.84,0.64,(0.95%)
338,Centerpoint Energy Inc,CNP,0.047827,26.68,-0.48,(-1.75%)
339,Darden Restaurants Inc,DRI,0.047736,143.44,2.01,(1.42%)
340,Hologic Inc,HOLX,0.047358,69.99,0.75,(1.08%)
341,First Solar Inc,FSLR,0.047324,161.90,3.29,(2.07%)
342,Expeditors Intl Wash Inc,EXPD,0.046936,114.74,1.08,(0.95%)
343,Brown & Brown Inc,BRO,0.046675,71.15,0.19,(0.26%)
344,Factset Research Systems Inc,FDS,0.046601,443.66,8.47,(1.95%)
345,Fifth Third Bancorp,FITB,0.046598,25.05,0.19,(0.74%)
346,Ventas Inc,VTR,0.046351,42.18,0.77,(1.85%)
347,Marathon Oil Corp,MRO,0.046321,27.51,0.12,(0.45%)
348,Steel Dynamics Inc,STLD,0.046096,106.96,0.52,(0.48%)
349,Bunge Ltd,BG,0.046038,110.67,1.10,(1.00%)
350,Ptc Inc,PTC,0.045951,140.25,1.78,(1.28%)
351,Everest Group Ltd,EG,0.04587,381.30,-0.42,(-0.11%)
352,Cincinnati Financial Corp,CINF,0.045852,104.40,-0.30,(-0.29%)
353,Enphase Energy Inc,ENPH,0.045679,121.39,1.28,(1.07%)
354,Nasdaq Inc,NDAQ,0.04562,49.07,0.74,(1.52%)
355,Akamai Technologies Inc,AKAM,0.045578,107.75,0.79,(0.74%)
356,Cboe Global Markets Inc,CBOE,0.045525,155.28,0.51,(0.33%)
357,Cf Industries Holdings Inc,CF,0.04496,84.93,1.48,(1.78%)
358,Waters Corp,WAT,0.044936,274.46,2.12,(0.78%)
359,Pultegroup Inc,PHM,0.044848,74.85,1.65,(2.25%)
360,Tyler Technologies Inc,TYL,0.044831,387.74,2.43,(0.63%)
361,Principal Financial Group,PFG,0.044705,72.74,0.74,(1.02%)
362,Clorox Company,CLX,0.04465,128.98,-0.17,(-0.13%)
363,Southwest Airlines Co,LUV,0.044478,27.30,0.49,(1.81%)
364,Regions Financial Corp,RF,0.044397,17.16,0.22,(1.27%)
365,Garmin Ltd,GRMN,0.044336,104.65,1.42,(1.38%)
366,Atmos Energy Corp,ATO,0.044128,106.32,-0.14,(-0.13%)
367,Netapp Inc,NTAP,0.044116,76.49,1.54,(2.05%)
368,Textron Inc,TXT,0.043659,79.27,0.33,(0.41%)
369,Cooper Cos Inc,COO,0.04361,318.15,2.23,(0.71%)
370,Kellogg Co,K,0.043517,58.90,-0.22,(-0.38%)
371,Idex Corp,IEX,0.043484,210.72,3.28,(1.58%)
372,Cms Energy Corp,CMS,0.043476,52.78,-0.57,(-1.07%)
373,Skyworks Solutions Inc,SWKS,0.042974,98.55,2.25,(2.33%)
374,Alexandria Real Estate Equit,ARE,0.042466,99.48,0.59,(0.60%)
375,Hunt (Jb) Transprt Svcs Inc,JBHT,0.042319,186.54,0.95,(0.51%)
376,Las Vegas Sands Corp,LVS,0.042222,45.63,-0.53,(-1.15%)
377,Ball Corp,BALL,0.042202,48.27,0.04,(0.08%)
378,Walgreens Boots Alliance Inc,WBA,0.04215,20.97,-0.06,(-0.26%)
379,Teradyne Inc,TER,0.041494,100.04,3.56,(3.68%)
380,Mid America Apartment Comm,MAA,0.041385,128.55,0.48,(0.37%)
381,Epam Systems Inc,EPAM,0.041006,257.76,0.96,(0.37%)
382,Avery Dennison Corp,AVY,0.040961,183.42,1.39,(0.76%)
383,Omnicom Group,OMC,0.040483,74.60,1.21,(1.65%)
384,Huntington Bancshares Inc,HBAN,0.040444,10.25,0.13,(1.24%)
385,Eqt Corp,EQT,0.040251,40.00,0.39,(0.99%)
386,Tyson Foods Inc Cl A,TSN,0.040042,49.74,-0.37,(-0.74%)
387,Western Digital Corp,WDC,0.039814,45.50,0.94,(2.11%)
388,Northern Trust Corp,NTRS,0.039557,69.29,0.84,(1.23%)
389,Carnival Corp,CCL,0.039206,14.52,0.54,(3.88%)
390,Expedia Group Inc,EXPE,0.038585,102.75,2.50,(2.49%)
391,United Airlines Holdings Inc,UAL,0.038383,42.84,0.81,(1.94%)
392,Quest Diagnostics Inc,DGX,0.038331,123.71,0.31,(0.25%)
393,Axon Enterprise Inc,AXON,0.03828,195.69,1.04,(0.53%)
394,Packaging Corp of America,PKG,0.038236,152.79,0.90,(0.59%)
395,Revvity Inc,RVTY,0.0378,110.55,1.50,(1.38%)
396,Snap on Inc,SNA,0.037774,257.97,4.00,(1.58%)
397,Pool Corp,POOL,0.037475,353.56,9.86,(2.87%)
398,Essex Property Trust Inc,ESS,0.03733,210.81,0.07,(0.03%)
399,Domino S Pizza Inc,DPZ,0.037258,382.39,2.18,(0.57%)
400,Amcor Plc,AMCR,0.037101,9.09,0.06,(0.61%)
401,Best Buy Co Inc,BBY,0.037071,68.66,0.29,(0.43%)
402,Apa Corp,APA,0.03662,42.49,0.11,(0.27%)
403,Lamb Weston Holdings Inc,LW,0.036553,91.47,0.09,(0.10%)
404,Wr Berkley Corp,WRB,0.036551,65.21,0.86,(1.33%)
405,Conagra Brands Inc,CAG,0.036484,27.44,-0.10,(-0.35%)
406,Lkq Corp,LKQ,0.036449,49.51,0.72,(1.47%)
407,Jm Smucker Co,SJM,0.035767,124.48,-0.96,(-0.77%)
408,Stanley Black & Decker Inc,SWK,0.035567,83.87,0.97,(1.17%)
409,Synchrony Financial,SYF,0.035241,30.73,0.55,(1.84%)
410,Carmax Inc,KMX,0.035202,71.64,-8.05,(-10.10%)
411,Leidos Holdings Inc,LDOS,0.034943,92.20,0.21,(0.23%)
412,Seagate Technology Holdings,STX,0.034918,65.71,1.42,(2.20%)
413,Paycom Software Inc,PAYC,0.034914,259.42,2.34,(0.91%)
414,Celanese Corp,CE,0.034212,127.11,3.81,(3.09%)
415,Trimble Inc,TRMB,0.034136,52.22,3.01,(6.12%)
416,Alliant Energy Corp,LNT,0.03411,48.06,-0.49,(-1.02%)
417,Citizens Financial Group,CFG,0.033972,26.28,0.52,(2.00%)
418,International Paper Co,IP,0.033961,35.10,0.15,(0.41%)
419,Masco Corp,MAS,0.033414,54.58,1.37,(2.58%)
420,Nordson Corp,NDSN,0.033057,223.81,3.73,(1.69%)
421,Loews Corp,L,0.032942,64.16,0.36,(0.56%)
422,Evergy Inc,EVRG,0.032792,50.48,-0.58,(-1.13%)
423,Mosaic Co,MOS,0.03266,35.63,0.43,(1.22%)
424,Molson Coors Beverage Co B,TAP,0.032624,62.29,-0.12,(-0.19%)
425,Zebra Technologies Corp Cl A,ZBRA,0.03257,236.95,11.04,(4.89%)
426,Viatris Inc,VTRS,0.032115,9.80,0.21,(2.14%)
427,Live Nation Entertainment In,LYV,0.032035,83.73,2.71,(3.34%)
428,Host Hotels & Resorts Inc,HST,0.03173,16.38,0.34,(2.11%)
429,Insulet Corp,PODD,0.031493,166.19,4.49,(2.77%)
430,Match Group Inc,MTCH,0.031269,40.07,0.09,(0.23%)
431,Interpublic Group of Cos Inc,IPG,0.031184,29.12,0.39,(1.35%)
432,Hormel Foods Corp,HRL,0.030887,38.15,-0.19,(-0.48%)
433,Incyte Corp,INCY,0.03067,58.93,-0.18,(-0.30%)
434,Udr Inc,UDR,0.030252,35.67,0.28,(0.79%)
435,Jack Henry & Associates Inc,JKHY,0.030211,150.61,2.17,(1.46%)
436,Kimco Realty Corp,KIM,0.029862,17.73,0.24,(1.34%)
437,Aes Corp,AES,0.029775,15.29,-0.65,(-4.05%)
438,Bio Techne Corp,TECH,0.029742,67.67,0.10,(0.15%)
439,Pentair Plc,PNR,0.029592,65.59,0.87,(1.34%)
440,Rollins Inc,ROL,0.029276,37.64,0.20,(0.52%)
441,Mgm Resorts International,MGM,0.028601,36.76,0.27,(0.74%)
442,Ceridian Hcm Holding Inc,CDAY,0.028589,67.38,0.35,(0.52%)
443,Brown Forman Corp Class B,BF.B,0.028542,56.78,0.14,(0.25%)
444,Nisource Inc,NI,0.028365,24.84,-0.35,(-1.37%)
445,Gen Digital Inc,GEN,0.028124,17.83,-0.07,(-0.37%)
446,C.H. Robinson Worldwide Inc,CHRW,0.028048,86.31,0.02,(0.02%)
447,Camden Property Trust,CPT,0.027984,94.56,-0.32,(-0.34%)
448,Charles River Laboratories,CRL,0.027736,195.69,0.75,(0.38%)
449,Healthpeak Properties Inc,PEAK,0.027617,18.15,0.10,(0.58%)
450,Caesars Entertainment Inc,CZR,0.027217,47.52,1.54,(3.36%)
451,Regency Centers Corp,REG,0.027131,59.98,0.85,(1.43%)
452,Keycorp,KEY,0.0269,10.52,0.22,(2.09%)
453,Henry Schein Inc,HSIC,0.026715,73.88,0.62,(0.84%)
454,Globe Life Inc,GL,0.026574,110.04,0.61,(0.56%)
455,Borgwarner Inc,BWA,0.026416,40.72,0.92,(2.31%)
456,F5 Inc,FFIV,0.026087,160.33,2.74,(1.74%)
457,Qorvo Inc,QRVO,0.025849,96.39,1.83,(1.93%)
458,Teleflex Inc,TFX,0.025796,199.42,2.91,(1.48%)
459,Allegion Plc,ALLE,0.025545,104.97,1.68,(1.63%)
460,Westrock Co,WRK,0.025292,35.98,0.23,(0.64%)
461,Eastman Chemical Co,EMN,0.025003,76.99,2.35,(3.15%)
462,Wynn Resorts Ltd,WYNN,0.024938,92.21,-0.00,(-0.00%)
463,Nrg Energy Inc,NRG,0.024681,38.55,-0.03,(-0.08%)
464,Juniper Networks Inc,JNPR,0.024655,27.92,0.42,(1.52%)
465,Pinnacle West Capital,PNW,0.02321,73.45,-0.71,(-0.95%)
466,Hasbro Inc,HAS,0.02308,65.23,0.24,(0.37%)
467,Catalent Inc,CTLT,0.023069,45.85,0.07,(0.15%)
468,American Airlines Group Inc,AAL,0.02296,13.00,0.39,(3.05%)
469,Fmc Corp,FMC,0.022942,66.03,0.02,(0.03%)
470,Campbell Soup Co,CPB,0.022776,41.15,-0.31,(-0.76%)
471,Smith (a.O.) Corp,AOS,0.022769,66.99,1.54,(2.35%)
472,Boston Properties Inc,BXP,0.02269,59.66,0.79,(1.34%)
473,Huntington Ingalls Industrie,HII,0.022502,204.41,1.22,(0.60%)
474,Fox Corp Class A,FOXA,0.021902,31.47,0.55,(1.76%)
475,Robert Half Inc,RHI,0.021872,73.78,0.64,(0.87%)
476,Assurant Inc,AIZ,0.021618,145.63,-0.13,(-0.09%)
477,Universal Health Services B,UHS,0.021551,127.00,2.80,(2.25%)
478,Etsy Inc,ETSY,0.021257,63.53,1.64,(2.65%)
479,Marketaxess Holdings Inc,MKTX,0.021132,205.89,4.11,(2.04%)
480,News Corp Class A,NWSA,0.0209,20.00,0.35,(1.76%)
481,Bio Rad Laboratories A,BIO,0.020548,356.10,3.63,(1.03%)
482,Bath & Body Works Inc,BBWI,0.020412,33.19,1.04,(3.23%)
483,Dentsply Sirona Inc,XRAY,0.020079,33.94,-0.17,(-0.51%)
484,Solaredge Technologies Inc,SEDG,0.020026,132.35,4.34,(3.39%)
485,Whirlpool Corp,WHR,0.019812,131.66,1.03,(0.79%)
486,Franklin Resources Inc,BEN,0.019128,24.55,0.28,(1.14%)
487,Generac Holdings Inc,GNRC,0.018958,110.73,1.84,(1.69%)
488,Norwegian Cruise Line Holdin,NCLH,0.018812,16.96,0.67,(4.08%)
489,Federal Realty Invs Trust,FRT,0.018475,91.45,1.05,(1.16%)
490,Tapestry Inc,TPR,0.01809,28.18,0.23,(0.84%)
491,Invesco Ltd,IVZ,0.017835,14.31,0.22,(1.53%)
492,Paramount Global Class B,PARA,0.017208,12.89,0.11,(0.89%)
493,Vf Corp,VFC,0.015631,16.59,-0.32,(-1.89%)
494,Comerica Inc,CMA,0.014638,41.07,1.12,(2.81%)
495,Davita Inc,DVA,0.014395,95.75,0.01,(0.01%)
496,Zions Bancorp Na,ZION,0.013918,33.96,0.79,(2.39%)
497,Ralph Lauren Corp,RL,0.013127,115.52,0.26,(0.22%)
498,Sealed Air Corp,SEE,0.012794,32.20,0.46,(1.46%)
499,Alaska Air Group Inc,ALK,0.012574,37.04,0.63,(1.73%)
500,Mohawk Industries Inc,MHK,0.011998,85.15,1.23,(1.46%)
501,Organon & Co,OGN,0.011665,16.93,0.34,(2.02%)
502,Dxc Technology Co,DXC,0.011658,20.64,0.29,(1.40%)
503,Fox Corp Class B,FOX,0.010545,29.16,0.53,(1.85%)
504,News Corp Class B,NWS,0.006575,20.75,0.36,(1.74%)
*/
